import {getData} from "./api/get-data";
import UlComponent from "./components/ul";
import CartItemsController from "./controllers/cart-items";
import {setCountCartHeader} from "./init-cart";
import {renderAccessories} from "./render-accessories";
import {renderGoods} from "./render-goods";
import {updateBonuses} from "./update-bonuses";
import {getFormattedPrice} from "./utils/get-formatted-price";
import {getProductNumeralEnding} from "./utils/get-numeral-ending";
import {render, RenderPosition, replace} from "./utils/render";


export const initCartPage = (shopInfoData) => {
  const cartPageElement = document.querySelector(`.cart-page`);
  const bonusWrapElement = cartPageElement.querySelector(`.cart-page__bonusWrap`);
  const totalPriceElement = cartPageElement.querySelector(`.cart-page__totalPrice`);
  const countCartElement = cartPageElement.querySelector(`.cart-page__count`);
  countCartElement.innerHTML = getProductNumeralEnding(cartData.cart_count);

  const totalWrapElement = cartPageElement.querySelector(`.cart-page__total`);

  const promocodeWrapElement = cartPageElement.querySelector(`.cart-page__promocodeWrap`);
  const cartListElement = cartPageElement.querySelector(`.cart-page__listItem`);
  let listComponent = null;

  const onDataChange = (container, response) => {
    cartData = response;
    setCountCartHeader(cartData.cart_count);

    if (cartData.bonus_allow) {
      // bonusWrapElement.dataset.mode = `input`;
      bonusWrapElement.dataset.show = `true`;
    } else {
      bonusWrapElement.dataset.show = `false`;
    }

    totalPriceElement.innerHTML = getFormattedPrice(cartData.fullprice);
    totalWrapElement.dataset.mode = +cartData.fullprice === 0 ? `hide` : `show`;
    countCartElement.innerHTML = getProductNumeralEnding(cartData.cart_count);

    renderItems(container, cartData.items);
  };


  const renderItems = (container, items) => {
    const oldComponent = listComponent;
    listComponent = new UlComponent(`cart-page__listItem`);

    new CartItemsController({
      items,
      shopInfoData,
      onDataChange: (response) => onDataChange(container, response),
    }).render(listComponent.getElement());

    if (oldComponent) {
      replace(listComponent, oldComponent);
    } else {
      render(cartPageElement.querySelector(`.cart-page__product`), listComponent.getElement(), RenderPosition.BEFOREEND);
    }
  };

  if (cartData.promo_allow) {
    const promocodeInputWrapElement = promocodeWrapElement.querySelector(`.cart-page__promocodeInput`);
    const promocodeInputElement = promocodeInputWrapElement.querySelector(`input`);
    const promocodeButton = promocodeWrapElement.querySelector(`.cart-page__promocodeButton`);
    const promocodeSendButton = promocodeWrapElement.querySelector(`.cart-page__promocodeSendButton`);
    const promocodeResetButton = promocodeWrapElement.querySelector(`.cart-page__promocodeResetButton`);
    const promocodeDeleteButton = promocodeWrapElement.querySelector(`.cart-page__promocodeDeleteButton`);
    const promocodeMessageElement = promocodeWrapElement.querySelector(`.cart-page__promocodeMessage`);

    const appliedPromocode = (data) => {
      promocodeInputWrapElement.dataset.mode = `apply`;
      promocodeInputElement.value = data.promo_name;
      promocodeMessageElement.innerHTML = `Промокод успешно применен`;

      totalPriceElement.innerHTML = getFormattedPrice(data.fullprice);
    };

    const notAppliedPromocode = (data) => {
      promocodeInputWrapElement.dataset.mode = `error`;
      promocodeMessageElement.innerHTML = `Промокод не найден`;

      totalPriceElement.innerHTML = getFormattedPrice(data.fullprice);
    };

    const resetPromocode = (data) => {
      promocodeMessageElement.innerHTML = ``;
      promocodeInputElement.value = ``;
      promocodeInputWrapElement.dataset.mode = `empty`;

      totalPriceElement.innerHTML = getFormattedPrice(data.fullprice);
    };

    if (!cartData.promo_entered) {
      promocodeWrapElement.dataset.mode = `button`;
    } else {
      promocodeWrapElement.dataset.mode = `input`;

      if (cartData.promo_used) {
        appliedPromocode(cartData);
      } else {
        notAppliedPromocode(cartData);
      }
    }

    promocodeInputElement.addEventListener(`input`, () => {
      const value = promocodeInputElement.value;
      promocodeInputWrapElement.dataset.mode = value ? `input` : `empty`;
    });

    promocodeButton.addEventListener(`click`, () => {
      promocodeWrapElement.dataset.mode = `input`;
    });

    promocodeSendButton.addEventListener(`click`, () => {
      const promocode = promocodeInputElement.value;

      getData({
        [`set_cart_promo`]: promocode
      })
      .then((response) => {
        cartData = response;

        if (!cartData.bonus_allow) {
          bonusWrapElement.dataset.show = cartData.bonus_allow;
          // bonusWrapElement.remove();
        }
        if (cartData.promo_used) {
          appliedPromocode(cartData);
        } else {
          notAppliedPromocode(cartData);
        }

        renderItems(cartListElement, cartData.items);
      });
    });

    promocodeResetButton.addEventListener(`click`, () => {
      getData({
        [`set_cart_promo`]: `-1`
      })
      .then((response) => {
        cartData = response;
        if (!cartData.bonus_allow) {
          bonusWrapElement.dataset.show = cartData.bonus_allow;
          // bonusWrapElement.remove();
        }
        resetPromocode(cartData);

        renderItems(cartListElement, cartData.items);
      });
    });

    promocodeDeleteButton.addEventListener(`click`, () => {
      promocodeInputElement.value = ``;
      promocodeInputWrapElement.dataset.mode = `empty`;
      promocodeMessageElement.innerHTML = ``;
    });
  } else {
    promocodeWrapElement.dataset.show = `false`;
    // promocodeWrapElement.remove();
  }


  // const updateBonuses = () => {
  //   if (!window.userSessionData) {
  //     return;
  //   }

  //   if (!cartData.bonus_allow) {
  //     return;
  //   }

  //   const bonusCountElement = bonusWrapElement.querySelector(`.cart-page__bonusCount`);
  //   const bonusInputWrapElement = bonusWrapElement.querySelector(`.cart-page__bonusInput`);
  //   const bonusInputElement = bonusInputWrapElement.querySelector(`input`);

  //   if (+cartData.bonus_used > 0) {
  //     bonusWrapElement.dataset.mode = `input`;
  //     bonusInputWrapElement.dataset.mode = `apply`;
  //     bonusInputElement.value = cartData.bonus_used;
  //     bonusCountElement.innerHTML = `Осталось ${getBonusNumeralEnding(+window.userSessionData.bonus_sum - +cartData.bonus_used)}`;
  //   } else {
  //     bonusWrapElement.dataset.mode = `button`;
  //     bonusInputWrapElement.dataset.mode = `empty`;
  //     bonusInputElement.value = ``;
  //     bonusCountElement.innerHTML = `У вас есть ${getBonusNumeralEnding(+window.userSessionData.bonus_sum)}`;
  //   }

  //   totalPriceElement.innerHTML = `${getFormattedPrice(cartData.fullprice)} <span>&#8381;</span>`;
  // };


  const bonusButton = bonusWrapElement.querySelector(`.cart-page__bonusButton`);
  const bonusInputWrapElement = bonusWrapElement.querySelector(`.cart-page__bonusInput`);
  const bonusInputElement = bonusInputWrapElement.querySelector(`input`);
  const bonusSendButton = bonusWrapElement.querySelector(`.cart-page__bonusSendButton`);
  const bonusResetButton = bonusWrapElement.querySelector(`.cart-page__bonusResetButton`);

  bonusButton.addEventListener(`click`, () => {
    bonusWrapElement.dataset.mode = `input`;
  });

  bonusInputElement.addEventListener(`input`, () => {
    const value = bonusInputElement.value;
    bonusInputWrapElement.dataset.mode = value ? `input` : `empty`;
  });

  bonusSendButton.addEventListener(`click`, () => {
    const bonus = bonusInputElement.value;

    getData({
      [`set_cart_bonus`]: bonus
    })
    .then((response) => {
      cartData = response;
      if (!cartData.promo_allow) {
        promocodeWrapElement.dataset.show = cartData.promo_allow;
      }
      updateBonuses();

      renderItems(cartListElement, cartData.items);
    });
  });

  bonusResetButton.addEventListener(`click`, () => {
    getData({
      [`set_cart_bonus`]: `-1`
    })
    .then((response) => {
      cartData = response;
      if (!cartData.promo_allow) {
        promocodeWrapElement.dataset.show = cartData.promo_allow;
      }
      updateBonuses();

      renderItems(cartListElement, cartData.items);
    });
  });

  if (cartData.bonus_allow) {
    // bonusWrapElement.dataset.mode = `input`;
    bonusWrapElement.dataset.show = `true`;
  } else {
    bonusWrapElement.dataset.show = `false`;
  }

  // showBonusWrap();


  totalPriceElement.innerHTML = getFormattedPrice(cartData.fullprice);
  totalWrapElement.dataset.mode = +cartData.fullprice === 0 ? `hide` : `show`;


  renderItems(cartListElement, cartData.items);

  Object.values(additionList).forEach((addition) => {
    if (addition.groups) {
      renderAccessories(cartPageElement.querySelector(`.cart-page__wrap`), `product-list-page`, addition);
    }
    if (addition.items) {
      renderGoods(cartPageElement.querySelector(`.cart-page__wrap`), `product-list-page`, `goods`, addition, (response) => onDataChange(cartPageElement.querySelector(`.cart-page__product`), response));
    }
  });
};
